import DataKonsul from "@/services/DataKonsul";
import {
  Konsul,
  ListKonsul,
  JawabKonsul,
  DetailKonsul,
  DetailSoap
} from "@/types";
import DataList from "@/services/DataList";
import { storeSoap } from "@/store/modules/soap";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { isNull } from "lodash";
import { userModule } from "./user";
import SuratKonsulSvc from "@/services/new/SuratKonsul";
// import { appModule } from "./app";

export interface KonsulState {
  konsul: { pasien: any; register: any } | any;
  jwbkonsul: JawabKonsul;
  detailkonsul: DetailKonsul[];
  // listKonsul: ListKonsul[];
  listKonsul: DetailKonsul[];
  soap: DetailSoap;
  errlistkonsul: string;
}

@Module({ store, dynamic: true, name: "storeKonsul" })
class KonsulStore extends VuexModule implements KonsulState {
  konsul: { pasien: any; register: any } | any = {};
  jwbkonsul = {} as JawabKonsul;
  detailkonsul: DetailKonsul[] = [];
  konsulMasuk: DetailKonsul[] = [];
  // listKonsul: ListKonsul[] = [];
  listKonsul: DetailKonsul[] = [];
  soap = {} as DetailSoap;
  errlistkonsul = "0";
  loading = false;

  @Mutation CLEAR_DATA() {
    this.konsul = null;
    this.jwbkonsul = null;
    this.detailkonsul = [];
    this.konsulMasuk = [];
    this.listKonsul = [];
    this.soap = null;
    this.errlistkonsul = "0";
    this.loading = false;
  }

  @Action clearRecords() {
    this.CLEAR_DATA();
  }

  @Action clear() {
    this.CLEAR_DATA();
  }

  @Mutation SET_KONSUL(konsul: Konsul) {
    this.konsul = konsul;
  }

  @Mutation SET_DETAIL_KONSUL(detailkonsul: DetailKonsul[]) {
    this.detailkonsul = detailkonsul.filter(it => {
      return !it.type || it.type === "rjkint";
    });
  }

  @Mutation SET_KONSUL_MASUK(detailkonsul: DetailKonsul[]) {
    this.konsulMasuk = detailkonsul.filter(it => {
      return !it.type || it.type === "rjkint";
    });
  }

  @Mutation SET_JAWAB_KONSUL(jwbkonsul: JawabKonsul) {
    this.jwbkonsul = jwbkonsul;
  }

  @Mutation SET_LIST_KONSUL(listKonsul: DetailKonsul[]) {
    this.listKonsul = listKonsul;
  }

  @Mutation SET_ERR_LIST_KONSUL(errlistkonsul: string) {
    this.errlistkonsul = errlistkonsul;
  }

  @Mutation SET_LOADING(loading: boolean) {
    this.loading = loading;
  }

  @Action actKonsul_on_reg(reg) {
    const dt = DataKonsul.getDataKonsul(reg);
    dt.then(dt => {
      const konsul = dt.data;
      // this.checkDetailKonsul(konsul)
      this.SET_KONSUL(konsul);
      if (konsul.suratKonsul.length > 0) {
        const detailkonsul = dt.data.suratKonsul;
        this.SET_DETAIL_KONSUL(detailkonsul);
        if (!isNull(detailkonsul[0].jawaban)) {
          const jawabkonsul = dt.data.suratKonsul[0].jawaban;
          this.SET_JAWAB_KONSUL(jawabkonsul);
        } else {
          this.SET_JAWAB_KONSUL(null);
        }
      } else {
        this.SET_DETAIL_KONSUL(konsul.suratKonsul);
        this.SET_JAWAB_KONSUL(null);
      }
    });
  }

  // @Action act_on_reg_new_konsul(reg) {
  //   const dt = DataKonsul.getDataKonsul(reg);
  //   dt.then(dt => {
  //     const konsul = dt.data;
  //     const assesment = storeSoap.detailSoap[0].a;
  //     const detailkonsul: DetailKonsul[] = [
  //       {
  //         id: "",
  //         register_id: 0,
  //         pasien_rm: 0,
  //         unit_pengirim_id: "",
  //         unit_tujuan: 0,
  //         dr_pengirim_id: 0,
  //         dr_tujuan_id: 0,
  //         diagnosis: assesment,
  //         masalah: "",
  //         konsultasi: "",
  //         obat: ""
  //       }
  //     ];
  //     this.SET_DETAIL_KONSUL(detailkonsul);
  //     this.SET_KONSUL(konsul);
  //   });
  // }

  // @Action act_on_reg_new_jawab(reg) {
  //   const dt = DataKonsul.getDataKonsul(reg);
  //   dt.then(dt => {
  //     const konsul = dt.data;
  //     const jawabkonsul: JawabKonsul = {
  //       note: "",
  //       surat_konsul_id: 0,
  //       dokter: "",
  //       soap: {
  //         s: "",
  //         o: "",
  //         a: "",
  //         p: ""
  //       }
  //     };
  //     // console.log('xxxx')
  //     this.SET_JAWAB_KONSUL(jawabkonsul);
  //     this.SET_KONSUL(konsul);
  //   });
  // }

  @Action actKonsul_on_id(id) {
    const dt = DataKonsul.getDataKonsulByID(id);
    dt.then(dt => {
      const konsul = dt.data;
      this.SET_KONSUL(konsul);
      this.SET_LOADING(false);
    });
  }

  paramUnitId = null;
  paramSort = "-created_at";
  paramTglStart = null;
  paramTglEnd = null;

  @Mutation
  SET_PARAM_UNIT(val: string) {
    this.paramUnitId = val;
  }

  @Mutation
  SET_PARAM_SORT(val: string) {
    this.paramSort = val;
  }

  @Mutation
  SET_PARAM_TGL_START(val: string) {
    this.paramTglStart = val;
  }

  @Mutation
  SET_PARAM_TGL_END(val: string) {
    this.paramTglEnd = val;
  }

  @Action act_on_list_konsul(param) {
    if (userModule.isSignedIn == true) {
      const dt = DataList.getListPasienKonsulan(
        param.kdPoli,
        param.sort,
        param.tglStart,
        param.tglEnd
      );
      dt.then(dt => {
        if (dt?.["status"] != 1) {
          this.SET_ERR_LIST_KONSUL("1");
          // appModule.sendErrorAlert(dt.err);
          // console.log("err ", dt.err)
          // appModule.NoticeDelayAlert(dt.err);
        } else {
          this.SET_ERR_LIST_KONSUL("0");
          const listkonsul = dt.data;
          // console.log(listkonsul)
          this.SET_LIST_KONSUL(listkonsul);
        }
      });
    }
  }

  @Action({ rawError: true })
  getListKonsulWithoutParam() {
    if (userModule.isSignedIn == true) {
      this.SET_LOADING(true);

      const dt = DataList.getListPasienKonsulan(
        this.paramUnitId,
        this.paramSort,
        this.paramTglStart,
        this.paramTglEnd
      )
        .then(dt => {
          if (dt?.["status"] != 1) {
            this.SET_ERR_LIST_KONSUL("1");
            // appModule.sendErrorAlert(dt.err);
            // console.log("err ", dt.err)
            // appModule.NoticeDelayAlert(dt.err);
          } else {
            this.SET_ERR_LIST_KONSUL("0");
            const listkonsul = dt.data;
            // console.log(listkonsul)
            this.SET_LIST_KONSUL(listkonsul);
          }
        })
        .finally(() => {
          this.SET_LOADING(false);
        });
    }
  }

  @Action({ rawError: true })
  getListKonsulRanap(params = null) {
    if (userModule.isSignedIn == true) {
      this.SET_LOADING(true);

      SuratKonsulSvc.getListKonsulRanap(this.paramUnitId, {
        sort: this.paramSort,
        tglStart: this.paramTglStart,
        tgllEnd: this.paramTglEnd
      })
        .then(resp => {
          console.log("getListKonsulRanap", resp);

          if (resp.status != 1) {
            this.SET_ERR_LIST_KONSUL("1");
            // appModule.sendErrorAlert(dt.err);
            // console.log("err ", dt.err)
            // appModule.NoticeDelayAlert(dt.err);
          } else {
            this.SET_ERR_LIST_KONSUL("0");
            const listkonsul = resp.data;
            this.SET_LIST_KONSUL(listkonsul);
          }
        })
        .finally(() => {
          this.SET_LOADING(false);
        });
    }
  }

  @Action
  getKonsulMasuk(reg) {
    const dt = SuratKonsulSvc.getKonsulMasukByReg(reg);

    dt.then(dt => {
      const konsul = dt.data;
      // this.checkDetailKonsul(konsul)
      // this.SET_KONSUL(konsul);

      if (konsul.suratKonsul.length > 0) {
        const detailkonsul = dt.data.suratKonsul;
        this.SET_KONSUL_MASUK(detailkonsul);
        // if (!isNull(detailkonsul[0].jawaban)) {
        //   const jawabkonsul = dt.data.suratKonsul[0].jawaban;
        //   this.SET_JAWAB_KONSUL(jawabkonsul);
        // } else {
        //   this.SET_JAWAB_KONSUL(null);
        // }
      } else {
        this.SET_KONSUL_MASUK(konsul.suratKonsul);
        // this.SET_JAWAB_KONSUL(null);
      }
    });
  }
}

export const storeKonsul = getModule(KonsulStore);
